import { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
function usePlaceholder() {
  const [focused, setFocused] = useState(false);

  return { focused, setFocused };
}
export const ContactItems = forwardRef(
  ({ label, placeholder, border, error, ...props }, ref) => {
    const { focused, setFocused } = usePlaceholder();
    const { t } = useTranslation();

    return (
      <div className="px-[20px] py-[5px]">
        <p className="text-4 mb-[4px] text-[--color-title]">{label}</p>
        <input
          ref={ref}
          className={`w-full rounded-[30px] ${border ? "border border-[#565ADD]" : null} p-[12px] focus:border focus:border-solid focus:border-[#565ADD] focus:shadow-focus-input focus:outline-none`}
          placeholder={focused ? "" : placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          // type="text"
          {...props}
        />
        {error && (
          <span className="mt-1 text-sm text-red-500">{t(error.message)}</span>
        )}
      </div>
    );
  },
);
